import { Component, OnInit } from '@angular/core';
import { LeagueService } from '../../shared/services/league.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { MatchService } from '../../shared/services/match.service';
import { MatchGetScore, MatchScore } from '../../shared/models/match.model';
import { first } from 'rxjs';
import { CommonModule,Location } from '@angular/common';
import { CoreService } from '../../shared/services/core.service';
import { IMatchDetails, ISubMatch } from './score.model';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-score',
  templateUrl: './score.component.html',
  styleUrls: ['./score.component.css']
})


export class ScoreComponent implements OnInit{
  matchId:any;
  players: { id: number; userName: string }[] = [];
  homeTeamPlayers: any[] = [];
  awayTeamPlayers: any[] = [];
  matches: any[] = [];
  matchDetails!: IMatchDetails;
  leagueId: any;
  validationErrors: any = {};
  isFormValid: boolean = false;

  leagueName:string=''
  isSubmitted: boolean = false;
  statusFromScheduleList: boolean = false;

 areFieldsDisabled = false;
  isSubmitEnabled = true;
  isEditEnabled = false;
  submitButtonText = 'Submit';
  submittedStatus!: string;



  
  
 ngOnInit() {
  this.route.queryParamMap.subscribe(params => {
    this.matchId = params.get('matchId');
    this.leagueName = params.get('leagueName') ?? '';
    this.getTeamScore();
  });
}

  
  constructor(private coreService: CoreService,private router: Router,private route:ActivatedRoute) { }
  getTeamScore() {
    this.coreService.isLoading.next(true);
    this.coreService.getApi(`/api/Match/GetTeamMatchScoreSummary?matchId=${this.matchId}`).subscribe({
      next: (res: IMatchDetails) => {
        this.coreService.isLoading.next(false);
        this.matchDetails = res;
        this.areFieldsDisabled = this.hasScores(this.matchDetails); 
        this.isEditEnabled = this.areFieldsDisabled;               
        this.isSubmitEnabled = !this.areFieldsDisabled;           
        this.submitButtonText = this.areFieldsDisabled ? 'Resubmit Score' : 'Submit Score';
        this.leagueId=res.leagueId
        this.getTeamPlayers();
       
      },
      error: () => this.coreService.isLoading.next(false),
    });
  }
    
  hasScores(matchScore: IMatchDetails): boolean {
  return !!matchScore.subMatches?.some(sub =>
    (sub.homePlayerSet1 > 0 || sub.homePlayerSet2 > 0 || sub.homePlayerSet3 > 0) ||
    (sub.awayPlayerSet1 > 0 || sub.awayPlayerSet2 > 0 || sub.awayPlayerSet3 > 0)
  );
}

get isSubmitDisabled(): boolean {
  return !this.isSubmitEnabled || !this.isFormValid || this.matches.length === 0;
}

  enableForm() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to edit the submitted score?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Edit',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.areFieldsDisabled = false;
        this.isEditEnabled = false;
        this.isSubmitEnabled = true;
        this.submitButtonText = 'Resubmit Score';

        this.validationErrors = {};
        this.updateFormValidity();
      }
    });
  }
  getTeamPlayers(){
    this.coreService.isLoading.next(true);
    this.coreService.getApi(`/api/League/GetLeagueTeams?leagueId=${this.leagueId}`).subscribe({
      next: (res: any) => {
        this.coreService.isLoading.next(false);
        this.homeTeamPlayers = res[0].members;
        this.awayTeamPlayers = res[1].members;
        this.players = [...this.homeTeamPlayers, ...this.awayTeamPlayers];
        console.log(this.homeTeamPlayers)
        console.log(this.awayTeamPlayers)
        this.generateMatchesFromSubMatches();
       
      },
      error: () => this.coreService.isLoading.next(false),
    });
  }

 
  
  generateMatchesFromSubMatches() {
    if (!this.matchDetails?.subMatches) return;

    this.matches = this.matchDetails.subMatches.map((subMatch, index) => {
      const isDoubles = index < this.matchDetails.doublesCount;

      return {
        subMatchId: subMatch.subMatchId,
        matchId: subMatch.matchId,
        isDoubles,
        team1: {
          player1: this.players.find(p => p.id === subMatch.homePlayer1Id) || null,
          player2: isDoubles ? this.players.find(p => p.id === subMatch.homePlayer2Id) || null : null,
          set1: subMatch.homePlayerSet1,
          set2: subMatch.homePlayerSet2,
          set3: subMatch.homePlayerSet3,
          default: !!subMatch.homePlayerWinByDefault,
          retired: !!subMatch.homePlayerRetired,
        },
        team2: {
          player1: this.players.find(p => p.id === subMatch.awayPlayer1Id) || null,
          player2: isDoubles ? this.players.find(p => p.id === subMatch.awayPlayer2Id) || null : null,
          set1: subMatch.awayPlayerSet1,
          set2: subMatch.awayPlayerSet2,
          set3: subMatch.awayPlayerSet3,
          default: !!subMatch.awayPlayerWinByDefault,
          retired: !!subMatch.awayPlayerRetired,
        }
      };
    });
  }
  
  
  submit() {
    this.checkDuplicatePlayers();
    if (this.hasValidationErrors()) {
      return;
    }
    const updatedSubMatches: ISubMatch[] = this.matches.map((match) => {
      return {
        subMatchId: match.subMatchId,
        matchId: match.matchId,
        homePlayer1Id: match.team1.player1?.id ?? 0,
        homePlayer2Id: match.isDoubles ? (match.team1.player2?.id ?? 0) : 0,
        awayPlayer1Id: match.team2.player1?.id ?? 0,
        awayPlayer2Id: match.isDoubles ? (match.team2.player2?.id ?? 0) : 0,
        homePlayerSet1: match.team1.set1 ?? 0,
        homePlayerSet2: match.team1.set2 ?? 0,
        homePlayerSet3: match.team1.set3 ?? 0,
        awayPlayerSet1: match.team2.set1 ?? 0,
        awayPlayerSet2: match.team2.set2 ?? 0,
        awayPlayerSet3: match.team2.set3 ?? 0,
        homePlayerWinByDefault: match.team1.default ?? false,
        awayPlayerWinByDefault: match.team2.default ?? false,
        homePlayerRetired: match.team1.retired ?? false,
        awayPlayerRetired: match.team2.retired ?? false,
    
        winningTeam: null,
        round: match.round ?? 0,
    
        homePlayer1Name: match.team1.player1?.userName ?? '',
        homePlayer2Name: match.isDoubles ? (match.team1.player2?.userName ?? '') : '',
        awayPlayer1Name: match.team2.player1?.userName ?? '',
        awayPlayer2Name: match.isDoubles ? (match.team2.player2?.userName ?? '') : ''
      };
    });
    
    const payload: ISubMatch[] = updatedSubMatches;
    this.coreService.isLoading.next(true);
    this.coreService.postApi(`/api/Match/SaveTeamMatchScore`,payload).subscribe({
      next: (res: boolean) => {
        this.coreService.isLoading.next(false);
        this.getTeamScore(); 
        this.areFieldsDisabled = true;     
        this.isEditEnabled = true;          
        this.isSubmitEnabled = false;       
        this.submitButtonText = 'Resubmit Score';
        this.goBack();
      },
      error: () => this.coreService.isLoading.next(false),
    });    
  }

    enableEdit() {
    this.areFieldsDisabled = false;
    this.isSubmitEnabled = true;
    this.isEditEnabled = false;
  }

  handleCheckboxChange(match: any, team: number, type: string) {
  // Reset all four checkboxes for this match
  match.team1.default = false;
  match.team1.retired = false;
  match.team2.default = false;
  match.team2.retired = false;

  // Set the clicked one to true
  match[`team${team}`][type] = true;
}


    
  // handleCheckboxChange(match: any, team: number, type: string) {
  //   if (type === 'default' && match[`team${team}`].default) {
  //     match[`team${team}`].retired = false;
  //   } else if (type === 'retired' && match[`team${team}`].retired) {
  //     match[`team${team}`].default = false;
  //   }
  // }
  
  onScoreInput(match: any, set: string, team1Score: any, team2Score: any, nextInput: any, index: number) {
    const errorKey = `${index}_${set}_error`;
    delete this.validationErrors[errorKey];
  
    const hasInput = team1Score !== null && team1Score !== undefined && team1Score !== '' ||
                     team2Score !== null && team2Score !== undefined && team2Score !== '';
  
    if (!hasInput){
      this.updateFormValidity();
      return;
    }
  
    const t1 = parseInt(team1Score, 10);
    const t2 = parseInt(team2Score, 10);
  
    if (isNaN(t1) || isNaN(t2)) return;
  
    if (t1 < 0 || t1 > 7 || t2 < 0 || t2 > 7) {
      this.validationErrors[errorKey] = 'Scores must be between 0 and 7';
      this.updateFormValidity();
      return;
      
    }
  

    // First allow 7-6 and 6-7
if ((t1 === 7 && t2 === 6) || (t2 === 7 && t1 === 6)) {
  return; // valid tie-break score
}

// 7 is only valid vs 5 or 6
if (t1 === 7 && !(t2 === 5 || t2 === 6)) {
  this.validationErrors[errorKey] =
    'If player wins with 7, opponent must have 5 or 6';
  this.updateFormValidity();
  return;
}

if (t2 === 7 && !(t1 === 5 || t1 === 6)) {
  this.validationErrors[errorKey] =
    'If player wins with 7, opponent must have 5 or 6';
  this.updateFormValidity();
  return;
}

// 6 is only valid vs 0-4 (NOT 5, unless it's 7-6 which we already handled)
if (t1 === 6 && t2 > 4) {
  this.validationErrors[errorKey] =
    'If player wins with 6, opponent must have 0-4';
  this.updateFormValidity();
  return;
}

if (t2 === 6 && t1 > 4) {
  this.validationErrors[errorKey] =
    'If player wins with 6, opponent must have 0-4';
  this.updateFormValidity();
  return;
}

    if (!this.validationErrors[errorKey]) {
      nextInput?.focus();
      
    }
    this.updateFormValidity();
  }
  
  hasValidationErrors(): boolean {
    return Object.keys(this.validationErrors).length > 0;
  }
  
  getValidationMessages(): string[] {
    return Object.values(this.validationErrors);
  }

  getFilteredHomePlayers(matchIndex: number, teamKey: string, playerKey: string) {
    const selectedPlayers = [
      this.matches[matchIndex].team1.player1,
      this.matches[matchIndex].team1.player2
    ].filter(p => p && p !== this.matches[matchIndex][teamKey][playerKey]);
  
    return this.homeTeamPlayers.filter(player =>
      !selectedPlayers.some(sel => sel?.id === player.id)
    );
  }
  
  getFilteredAwayPlayers(matchIndex: number, teamKey: string, playerKey: string) {
    const selectedPlayers = [
      this.matches[matchIndex].team2.player1,
      this.matches[matchIndex].team2.player2
    ].filter(p => p && p !== this.matches[matchIndex][teamKey][playerKey]);
  
    return this.awayTeamPlayers.filter(player =>
      !selectedPlayers.some(sel => sel?.id === player.id)
    );
  }
  
checkDuplicatePlayers() {
  this.validationErrors = {}; 

  const doublesPlayers: number[] = []; 

  for (let [index, match] of this.matches.entries()) {
    const team1Players = [match.team1.player1, match.team1.player2].filter(p => p);
    const team2Players = [match.team2.player1, match.team2.player2].filter(p => p);

    if (match.isDoubles) {
      if (team1Players.length === 2 && team1Players[0].id === team1Players[1].id) {
        this.validationErrors[`team1_duplicate_${index}`] =
          'Same player cannot play doubles with themselves';
        continue; 
      }
      if (team2Players.length === 2 && team2Players[0].id === team2Players[1].id) {
        this.validationErrors[`team2_duplicate_${index}`] =
          'Same player cannot play doubles with themselves';
        continue; 
      }
    }

    const allPlayers = [...team1Players, ...team2Players];
    const ids = allPlayers.map(p => p.id);
    const hasDuplicate = ids.some((id, i) => ids.indexOf(id) !== i);

    if (hasDuplicate) {
      this.validationErrors[`match_duplicate_${index}`] =
        'Same player cannot play for both teams in a match';
    }

    if (match.isDoubles) {
      for (let player of allPlayers) {
        if (doublesPlayers.includes(player.id)) {
          this.validationErrors[`doubles_conflict_${index}_${player.id}`] =
            `${player.userName} is already selected in another doubles match`;
        } else {
          doublesPlayers.push(player.id);
        }
      }
    }
  }

  this.updateFormValidity();
}


  updateFormValidity() {
    // No validation errors
    const noErrors = Object.keys(this.validationErrors).length === 0;

    // All matches must have valid player selection and all set scores filled
    let allValid = true;
    for (const match of this.matches) {
      // Team 1
      if (!match.team1.player1 || (match.isDoubles && !match.team1.player2)) {
        allValid = false;
        break;
      }
      // Team 2
      if (!match.team2.player1 || (match.isDoubles && !match.team2.player2)) {
        allValid = false;
        break;
      }
      // All sets must be filled (not null/undefined/empty string)
      const sets = [match.team1.set1, match.team1.set2, match.team1.set3, match.team2.set1, match.team2.set2, match.team2.set3];
      if (sets.some(s => s === null || s === undefined || s === '')) {
        allValid = false;
        break;
      }
      // At least one set score must be non-zero
      if (sets.every(s => s === 0)) {
        allValid = false;
        break;
      }
    }
    this.isFormValid = noErrors && allValid;
  }

   goBack() {
  const leagueId = this.matchDetails?.leagueId;
  const leagueName = (this.leagueName || '');
  this.router.navigate([`/my-match`], {
    queryParams: {
      tab: 'schedule',
      leagueId: leagueId,
      leagueName: leagueName
    }
  });
}

}